export default {
      id: "primary-care-usage",
      viewBox: "0 0 40.26 41.267",
      url: __webpack_public_path__ + "img/icons.8ad0c046.svg#primary-care",
      toString: function () {
        return this.url;
      }
    }